import { inventoryIcon, listIcon, scheduledIcon, bulkInventories } from "assets/icons/svgIcons";

export default [
    {
        id: "bulk-inventories",
        title: "Moh Inventories",
        icon: bulkInventories,
        pageTitle: "Moh Inventories",
        navLink: "/bulkInventories",
        type: "item",
        isActive: true,
        permissions: ["super_admin", "moh_inventory"],
    },
];